import { defineMessages } from 'react-intl';

export const messages: {
	availableOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	availableOptions: {
		id: 'search-page.common.ui.quick-find.search-dialog-announcer.availableOptions',
		defaultMessage: '{count} options available',
		description:
			'Screen reader announcement for the number of search result options currently available in the Quick Find dialog',
	},
});
